// =============================================================================
// Mode devis dérivé de type_client (B2C / B2B …) — source unique, EXTENSIBLE
// =============================================================================
// La forme d'un devis se dérive du client rattaché, JAMAIS d'un gating tenant.
// Wizard partagé TEF + OMV + climat. Pour ajouter un 3e cas (ex. sous-traitance
// Climat) : ajouter une entrée DEVIS_MODES, l'aiguillage dans deriveDevisMode,
// et ses capacités dans devisModeCapabilities. Ne PAS introduire de booléen figé.

export const DEVIS_MODES = {
  B2C: "b2c",
  B2B: "b2b",
  // SOUS_TRAITANCE: "sous_traitance",  // À VENIR (Climat) — place réservée
};

// type_client considérés B2B (inclut le legacy "pro" de commercial_hub).
const B2B_TYPES = new Set([
  "professionnel", "entreprise", "copropriete", "bailleur", "pro",
]);

/** Dérive le mode du devis depuis le client rattaché. Défaut = B2C. */
export function deriveDevisMode(client) {
  const t = String(client?.type_client || "particulier").trim().toLowerCase();
  if (B2B_TYPES.has(t)) return DEVIS_MODES.B2B;
  // if (t === "...") return DEVIS_MODES.SOUS_TRAITANCE;  // à venir
  return DEVIS_MODES.B2C;
}

/**
 * Capacités d'affichage/règles par mode (masquage conditionnel, TVA défaut).
 * - showEntreprise : bloc entreprise (raison sociale/SIRET/représentant)
 * - showFiscalB2C  : blocs RFR / logement / couleur MPR (étape Client)
 * - showMPR        : case MaPrimeRénov' + reste-à-charge MPR (étape Aides)
 * - tvaDefaut      : taux TVA initial des nouvelles lignes sans taux (null = inchangé/B2C)
 */
export function devisModeCapabilities(mode) {
  switch (mode) {
    case DEVIS_MODES.B2B:
      return { showEntreprise: true, showFiscalB2C: false, showMPR: false, tvaDefaut: 20 };
    // case DEVIS_MODES.SOUS_TRAITANCE: return { ... };  // à venir
    case DEVIS_MODES.B2C:
    default:
      return { showEntreprise: false, showFiscalB2C: true, showMPR: true, tvaDefaut: null };
  }
}
